import { useApi } from './api';

export interface UserSettings {
  custom_prompt: string;
  selected_companies: number[];
  selected_boards: number[];
}

export const useSettingsApi = () => {
  const { fetchWithAuth } = useApi();

  /**
   * Fetch user settings from the API
   * @param userId The user ID to fetch settings for
   */
  const fetchUserSettings = async (userId: number): Promise<UserSettings> => {
    try {
      const data = await fetchWithAuth(`/api/user-settings?user_id=${userId}`);
      return {
        custom_prompt: data.custom_prompt || '',
        selected_companies: data.selected_companies || [],
        selected_boards: data.selected_boards || []
      };
    } catch (error) {
      console.error('Error fetching user settings:', error);
      // Return default settings on error
      return {
        custom_prompt: '',
        selected_companies: [],
        selected_boards: []
      };
    }
  };

  /**
   * Save user settings to the API
   * @param userId The user ID to save settings for
   * @param settings The settings to save
   */
  const saveUserSettings = async (userId: number, settings: UserSettings): Promise<boolean> => {
    try {
      await fetchWithAuth(`/api/user-settings?user_id=${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(settings)
      });
      return true;
    } catch (error) {
      console.error('Error saving user settings:', error);
      return false;
    }
  };

  return {
    fetchUserSettings,
    saveUserSettings
  };
}; 